export default [
  {
    icon: "icon-search", label: "Appliance Search",
    target: "/appliance-search", activeWhen: [/^\/appliance-search\/?[^\/]+/]
  }
];
